import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { toPointer } from '../../core/issues.js';

const FORBIDDEN: Array<{
  field: 'skills' | 'entities' | 'metrics';
  code: string;
  message: string;
}> = [
  {
    field: 'skills',
    code: 'gameshow.skills.array-forbidden',
    message:
      'A \'skills\' array is not allowed on storyData. Skills are metadata only — declare them in fields.indexing.skillsList on the envelope. Gameshows do not award skills through gameplay.',
  },
  {
    field: 'entities',
    code: 'gameshow.entities.forbidden',
    message: 'Use \'characters\' (not \'entities\') to declare the cast — matches example.json.',
  },
  {
    field: 'metrics',
    code: 'gameshow.metrics.forbidden',
    message: 'Use \'scoreDefinitions\' (not \'metrics\') — matches example.json.',
  },
];

export const topLevelForbiddenFields: Rule<Gameshow> = {
  code: 'gameshow.top-level.forbidden-field',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];
    const raw = input as unknown as Record<string, unknown>;
    for (const { field, code, message } of FORBIDDEN) {
      if (raw[field] === undefined) {
        continue;
      }
      const path: (string | number)[] = [field];
      issues.push({
        code,
        severity: 'error',
        message,
        path,
        pointer: toPointer(path),
        currentValue: raw[field],
        constraint: { kind: 'custom', detail: `top-level '${field}' not allowed` },
      });
    }
    return issues;
  },
};
